import { render, staticRenderFns } from "./ShippingLabels.vue?vue&type=template&id=53c3f8d4"
import script from "./ShippingLabels.vue?vue&type=script&lang=ts"
export * from "./ShippingLabels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports